/**
 * @generated SignedSource<<35e2357d172ddd48fd5907ec45de2798>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RegisterOrganizationUserInput = {
  recaptchaResponse?: string | null;
  token: string;
  user: UserInput;
};
export type UserInput = {
  acceptPrivacyPolicy: boolean;
  acceptTermsAndConditions: boolean;
  acceptedPrivacyPolicyId: string;
  acceptedTermsAndConditionsId: string;
  credential: CredentialInput;
  customFields?: any | null;
  name: string;
};
export type CredentialInput = {
  email: string;
  password: string;
};
export type RegisterWithInvite_registerOrganizationUser_Mutation$variables = {
  input: RegisterOrganizationUserInput;
};
export type RegisterWithInvite_registerOrganizationUser_Mutation$data = {
  readonly registerOrganizationUser: {
    readonly user: {
      readonly email: string;
      readonly name: string;
    };
  } | null;
};
export type RegisterWithInvite_registerOrganizationUser_Mutation = {
  response: RegisterWithInvite_registerOrganizationUser_Mutation$data;
  variables: RegisterWithInvite_registerOrganizationUser_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RegisterWithInvite_registerOrganizationUser_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RegisterOrganizationUserPayload",
        "kind": "LinkedField",
        "name": "registerOrganizationUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RegisterWithInvite_registerOrganizationUser_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RegisterOrganizationUserPayload",
        "kind": "LinkedField",
        "name": "registerOrganizationUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "013042988fa145239e4e5806a11a7c48",
    "id": null,
    "metadata": {},
    "name": "RegisterWithInvite_registerOrganizationUser_Mutation",
    "operationKind": "mutation",
    "text": "mutation RegisterWithInvite_registerOrganizationUser_Mutation(\n  $input: RegisterOrganizationUserInput!\n) {\n  registerOrganizationUser(input: $input) {\n    user {\n      name\n      email\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "176935b723087ac6a69cb216150087c8";

export default node;
